// src/components/store/sections/faqs/FaqV79OrigamifaqSunsetAmber.tsx
"use client";

import React from "react";
import DynamicFaqVariant from "./DynamicFaqVariant";

export default function FaqV79OrigamifaqSunsetAmber(props: any) {
  return (
    <DynamicFaqVariant
      variantNumber={79}
      archKey="origami_faq"
      archLabel="Origami Ribbon Panels"
      palName="SunsetAmber"
      grad="from-amber-500 via-orange-500 to-red-600"
      lightBg="bg-amber-50"
      textCol="text-amber-800"
      borderCol="border-amber-200"
      btnCls="bg-orange-600 hover:bg-orange-700"
      hexCol="#f59e0b"
      {...props}
    />
  );
}
